<div class="buffer" *ngIf="payCycle"></div>

<div class="main-calendar-container flex flex-column" *ngIf="orderedPayCycles.length > 0">
	<!-- Pay cycle selector -->
	<div class="calendar-top-section flex-row" *ngIf="orderedPayCycles.length">
		<!-- Year selector -->
		<div class="year-select">
			<span class="year flex-align-center-center">{{ selectedYear }}</span>
			<span class="flex-row flex-align-center-center">
				<app-icon
					id="previousYearButton"
					class="indicator year-next"
					(click)="previousYear()"
					[name]="'arrow-left-1'"
					[color]="'var(--color-primary-1000)'"
					[size]="'25'"
					[lineWidth]="'3.5px'"
				></app-icon>
				<app-icon
					id="nextYearButton"
					class="indicator year-next"
					(click)="nextYear()"
					[name]="'arrow-right-1'"
					[color]="'var(--color-primary-1000)'"
					[size]="'25'"
					[lineWidth]="'3.5px'"
				></app-icon>
			</span>
		</div>
		<div class="month-run-container">
			<app-icon
				id="previousMonthIcon"
				class="indicator month-next flex-align-center-center"
				(click)="previousCycle()"
				[name]="'arrow-left-1'"
				[color]="'var(--color-primary-1000)'"
				[size]="'25'"
				[lineWidth]="'3.5px'"
			></app-icon>
			<div
				*ngIf="!isCalendarRoute && payCycle?.errors?.before"
				class="milestone-errors-counter flex-align-center-center"
			>
				<span class="milestone-errors-counter-text before">
					{{ payCycle.errors.before }}
				</span>
			</div>
			<div
				class="paycycle-run flex-align-center-center"
				[matMenuTriggerFor]="cycleNavigationMenu"
				(menuOpened)="switchOrderedPayCycles(payCycle)"
				#triggerMenu="matMenuTrigger"
			>
				<span class="cycle-name" [attr.data-test]="payCycle.name | lowercase">
					{{ payCycle.payrollCycleId ? payCycle.name + " - " + payCycle.payrollCycleId : payCycle.name }}
				</span>
			</div>

			<div
				*ngIf="!isCalendarRoute && payCycle?.errors?.after"
				class="milestone-errors-counter flex-align-center-center"
			>
				<span class="milestone-errors-counter-text after">
					{{ payCycle.errors.after }}
				</span>
			</div>
			<app-icon
				id="nextMonthIcon"
				class="indicator month-next flex-align-center-center"
				(click)="nextCycle()"
				[name]="'arrow-right-1'"
				[color]="'var(--color-primary-1000)'"
				[size]="'25'"
				[lineWidth]="'3.5px'"
			></app-icon>
		</div>
		<div class="edit-offcycle-container">
			<button
				type="button"
				*ngIf="isCalendarRoute && canEditCycle"
				mat-button
				class="edit-offcycle-btn"
				(click)="editCycle(payCycle!)"
			>
				<app-icon class="icon-edit-offcycle" size="20" name="edit-2" color="#767676"></app-icon> EDIT CYCLE
			</button>
		</div>
	</div>

	<mat-divider class="mat-div-calendar-bottom"></mat-divider>

	<!-- Year and month selectors -->
	<div class="month-row">
		<!-- Month selector -->

		<ng-container *ngIf="payGroupFrequency === 'MONTHLY' || payGroupFrequency === 'BI_MONTHLY'">
			<div
				class="month-container flex flex-column flex-align-center-space-evenly"
				*ngFor="let row of organisedMonthNames; let i = index"
				(click)="onCycleClick(i, payCycle!, 'monthly')"
			>
				<span
					id="month-button"
					class="month"
					[ngClass]="{ 'selected-month-item': i === middle || overlappingCheck(i) }"
					[attr.data-test]="row | lowercase"
					>{{ row }}
					<app-hover-object
						*ngIf="milestones.length > 0"
						[type]="'dark-milestone-counter'"
						[milestone]="milestones"
						[month]="row"
					></app-hover-object>
				</span>

				<div *ngIf="i === middle" class="month-underline"></div>
			</div>
		</ng-container>

		<!-- Week selector -->

		<ng-container
			*ngIf="
				payGroupFrequency === 'WEEKLY' ||
				payGroupFrequency === 'BI_WEEKLY' ||
				(payGroupFrequency === 'FOUR_WEEKLY' && shownPayCycleWeeks.length > 0)
			"
		>
			<div
				class="month-container flex flex-column flex-align-center-center"
				*ngFor="let payCycleWeek of shownPayCycleWeeks; let i = index"
				(click)="onCycleClick(i, payCycle!, 'weekly')"
			>
				<span id="week-button" class="week" [ngClass]="{ 'offcycle-week': payCycleWeek.type === 'OFF_CYCLE' }">
					{{ payCycleWeek.label }}

					<app-hover-object
						*ngIf="milestones.length > 0"
						[type]="'dark-milestone-counter'"
						[milestone]="milestones"
						[cycleWeekStart]="payCycleWeek.startDate"
						[cycleWeekEnd]="payCycleWeek.endDate"
					></app-hover-object>
				</span>

				<div *ngIf="selectedCycleWeekId === payCycleWeek.id" class="month-underline"></div>
			</div>
		</ng-container>
	</div>

	<mat-divider class="mat-div-calendar-bottom margin-mid flex flex-row"></mat-divider>

	<!-- Day selector -->
	<div class="calendar-days-row">
		<!-- Left arrow -->
		<!--<button type="button" class="arrow" mat-icon-button (click)="onCycleClick(3, payCycle, 'monthly')">
			<app-icon
				[name]="'arrow-left-1'"
				[color]="'var(--color-primary-1000)'"
				[size]="'25'"
				[lineWidth]="'3.5px'"
			></app-icon>
		</button>-->

		<!-- Days -->
		<div class="daysrow flex flex-row">
			<div class="days-container" *ngFor="let date of calendar; let i = index; first as isFirst; last as isLast">
				<!-- Day -->
				<div
					class="day-container"
					(click)="setSelectedDate(date.date, true)"
					[ngClass]="{
						disabled: date.date.getMonth() !== currentMonth,
						today: date.isToday,
						bold: date.date.getDay() !== 0 && date.date.getDay() !== 6
					}"
				>
					<!-- Day of week -->
					<div
						class="weekdays flex-row"
						[ngClass]="{
							today: date.isToday
						}"
					>
						{{ date.date.toLocaleDateString("US", { weekday: "short" }).split("", 1)[0] }}
					</div>

					<!-- Number of day -->
					<div
						class="day"
						[ngClass]="{
							disabled: date.date.getMonth() !== currentMonth,
							today: date.isToday,
							bold: date.date.getDay() !== 0 && date.date.getDay() !== 6
						}"
						[attr.data-test]="'calendar-day'"
					>
						{{ date.date.getDate() }}
					</div>
				</div>

				<!-- Milestones -->
				<app-hover-object *ngIf="date.milestoneArray.length > 0" [date]="date"></app-hover-object>
			</div>
		</div>

		<!-- Right arrow -->
		<!--<button type="button" class="arrow" mat-icon-button (click)="onCycleClick(5, payCycle, 'monthly')">
			<app-icon
				[name]="'arrow-right-1'"
				[color]="'var(--color-primary-1000)'"
				[size]="'25'"
				[lineWidth]="'3.5px'"
			></app-icon>
		</button>-->
	</div>
	<!--<mat-divider class="mat-div-calendar-bottom margin-small" fxLayout="row"></mat-divider>-->

	<div class="bottom-calendar-container flex-row">
		<!--Today button-->
		<button type="button" mat-button class="today-btn" (click)="resetToToday()" [attr.data-test]="'today'">
			Today
		</button>
	</div>
</div>

<!-- Run Navigation Menu -->
<mat-menu class="navigation-menu" #cycleNavigationMenu="matMenu">
	<ng-template matMenuContent>
		<div class="matMenuContentDisplay">
			<div class="navigation-menu-years-container flex flex-column flex-1" style="--max-width: 30%">
				<div (click)="$event.stopPropagation()" *ngFor="let item of navigationMenuYears">
					<button
						type="button"
						class="navigation-menu-years-button"
						(click)="getOrderedPayCycles(item)"
						[disableRipple]="true"
						mat-menu-item
					>
						<span class="navigation-year-button-text"> {{ item }}</span>
					</button>
				</div>
			</div>
			<div class="navigation-menu-months-container flex-1" style="--max-width: 70%">
				<div *ngFor="let cycle of orderedPayCycles; index as i" class="flex-align-center-start">
					<button
						type="button"
						class="navigation-menu-cycles-button flex flex-row flex-align-start"
						(click)="generateCalendarDays(cycle)"
						mat-menu-item
					>
						<span class="navigation-cycle-button-text">
							{{ cycle.name }}
						</span>

						<div
							*ngIf="!isCalendarRoute && cycle.errors.own > 0"
							class="milestone-errors-counter-menu flex flex-align-center-center"
						>
							<span class="milestone-errors-counter-text">
								{{ cycle.errors.own }}
							</span>
						</div>
					</button>
				</div>
			</div>
		</div>
	</ng-template>
</mat-menu>
